import {httpClient} from "../../service";
import {Button} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {HttpMethod} from "../../model";
import ReactDOM from "react-dom";
import QRCode from 'qrcode.react';
import {TtaSecModel} from '../verifications/VerifyConfigModel';

const T1Detail = (props: any) => {
    const item: TtaSecModel = props.item;
    const [entity, setEntity] = useState<TtaSecModel>(item);
    const [loading, setLoading] = useState<boolean>(false);
    const qrTd = `qrTd${item.idx}`;
    const qrDiv = `qrDiv${item.idx}`;
    const verifyClick = async (e: any) => {
        e.preventDefault();
        console.log(`click button id=${e.target}`);

        const qrId = document.getElementById(qrDiv);
        setLoading(true);
        const url = `test/tta1`;
        const options = {
            method: HttpMethod.PUT,
            url,
            body: item
        }
        const act = await httpClient(options);
        if(qrId) {
            qrId.remove();
        }
        setLoading(false);
        if (act.result) {
            setEntity(act.data);
        } else {
            alert(act.errorMsg);
        }
    }
    const qrCodeClick = async (e: any) => {
        e.preventDefault();
        let id = document.getElementById(qrDiv);
        const qrId = document.getElementById(qrTd);
        console.log(`qrDiv:${id},qrId:${qrId},infoId:${item.infoId}`);
        if (qrId == null) return;
        if (id != null) {
            id.remove();
            return;
        }
        const body = {codeNum: `${item.idx}_${item.infoId}`};

        setLoading(true);
        const url = `test/encrypt`;
        const options = {
            method: HttpMethod.POST,
            url,
            body
        }
        const act = await httpClient(options);
        setLoading(false);

        if (act.result) {
            const qrCode = `qrTTA1_${act.data}`;
            let tag = document.createElement("div");
            tag.setAttribute("id", qrDiv);
            qrId.appendChild(tag);
            qrId.setAttribute("class","align-left");
            id = document.getElementById(qrDiv);
            ReactDOM.render(<QRCode value={qrCode} includeMargin={true}/>, id);
        } else {
            alert(act.errorMsg);
        }


    }
    let resultMsg: string = '';
    useEffect(() => {
        resultMsg = '검증전';
        if (item.id) {
            console.log(`id:${item.id},difSec=${item.difSec}`);
        }
    }, [item.idx]);

    if (entity.id) {
        if (entity.id > 0) {
            resultMsg = entity.result ? '성공' : `실패<div class="tta-error-msg">${entity.resultMsg}</div>`;
        } else {
            resultMsg = '검증전';
        }
    } else {
        resultMsg = '검증전';
    }
    return (

        <>
            <tr>
                <td>{item.idx}</td>
                <td>{item.shopId}</td>
                <td>{item.shopNm}</td>
                <td>
                    <Button className="btn-secondary" size="sm" onClick={qrCodeClick} disabled={loading}
                            style={{width: '80px', marginBottom: '10px'}}>QR스캔</Button>
                    <Button className="btn-primary" size="sm" onClick={verifyClick} disabled={loading}
                            style={{width: '80px'}}>검증하기</Button>

                </td>
                <td>
                    <div id={qrTd} className={'align-left'}>{entity.memo}</div>
                </td>
                <td>
                    {entity.startTime}
                </td>
                <td>
                    {entity.endTime}
                </td>
                <td>
                    {entity.difSec}
                </td>
                <td>
                    <div  dangerouslySetInnerHTML={{__html: resultMsg}}></div>
                </td>
            </tr>

        </>
    )
}
export default T1Detail;
